import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Card, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {Settings, PrintTwoTone, UndoTwoTone, SearchTwoTone} from '@material-ui/icons';
import DatasheetView from './DatasheetView';
// import moment from 'moment';
// import Toggle from './Toggle';
import ReactToPrint from 'react-to-print';
import DropDown from './DropDown';

export default class AggregateReport extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            cycles_array: [],
            roms_array: [],
            // show_employees: false,
            filters: {
                selected_cycle: null,
                selected_rom: "All",
            },
            generating_report: false,
            report_data_received: false,
            got_360_data: false,
            got_tm_data: false,
            got_cycles: false,
            got_roms: false,
            three_sixty_array: [],
            tm_array: [],
            selected_cycle: {},
            selected_rom: {},
            cycle_ave_360_score: 0,
        }

        this.state = this.initial_state;
        this.datasheetFieldSpecs_360 = [
            { field: 'name', headerName: 'Assessee', width: 160},
            { field: 'assessee_id', headerName: 'Empl. #', width: 110},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', width: 130, align:'center'},
            { field: 'assessment_count', headerName: '# Assessments', width: 140, sortable:false, align: 'center'},
            { field: 'final_average_score', headerName: 'Average Score', headerAlign:'right',align:'right', width: 160},
            { field: 'spacer', headerName: ' ', width: 225, sortable:false}
        ]

        this.datasheetFieldSpecs_tm = [
            { field: 'name', headerName: 'Assessee', width: 160},
            { field: 'assessee_id', headerName: 'Empl. #', width: 110},
            { field: 'store_code', headerName: 'Branch', width: 110,  align:'center',headerAlign:'center'},
            { field: 'reports_to_rom', headerName: 'Manager Code', width: 130, align:'center'},
            { field: 'KPI_final_score', headerName: 'KPI Score', headerAlign:'right',align:'right', width: 140},
            { field: 'PM_final_score', headerName: 'PM Score', headerAlign:'right',align:'right', width: 140},
            { field: 'final_classification', headerName: 'Classification', width: 150,headerAlign:'right',align: 'right'},
            { field: 'spacer', headerName: ' ', width: 120, sortable:false}
        ]
     

    }

    componentDidMount = () => {

        // async query open cycles...
        if (!this.state.got_cycles) {
            Gserv.sendCommand('query_open_cycles',this.props.gwt)
            .then(reply=>{
                // console.log('query_open_cycles reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    let cycles_array = [];
                    if (reply.Records){
                        reply.Records.forEach(cycle => {
                            cycles_array.push({id: cycle.id, name: cycle.cycle_code + " : " + cycle.cycle_name})
                        });
                    }
                    this.setState({cycles_array:cycles_array,got_cycles:true});
                }
            });
        }

        // async query roms...
        if (!this.state.got_roms && this.props.admin) {
            Gserv.sendCommand('query_roms',this.props.gwt)
            .then(reply=>{
                // console.log('query_roms reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_roms) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_roms) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    let roms_array = [{id: "All", name: "All"}];
                    if (reply.Records){
                        reply.Records.forEach(rom => {
                            roms_array.push({id:rom.rom_code, name: rom.name + " (" + rom.rom_code + ")"})
                        });
                    }
                    this.setState({roms_array:roms_array,got_roms:true});
                }
            });
        }

    };
    
    resetMe = () => {
        this.setState({
            error: false,
            error_message: '',
            generating_report: false,
            report_data_received: false,
            got_360_data: false,
            got_tm_data: false,
            three_sixty_array: [],
            tm_array: []
        });        
    }

    returnToSearch = () => {
        this.setState({
            error: false,
            error_message: '',
            generating_report: false,
            report_data_received: false,
            got_360_data: false,
            got_tm_data: false,
            three_sixty_array: [],
            tm_array: []
        })
    }

    handleFieldUpdate = (e) => {
        // console.log('e :>> ', e);
        let filters = this.state.filters;
        filters[e.field] = e.value;
        this.setState({filters:filters});
    }

    fetchAggregateData = () => {

        

        const cycles = this.state.cycles_array;
        const roms = this.state.roms_array;
        cycles.forEach(cycle => {
            if (cycle.id === Number(this.state.filters.selected_cycle)){
                this.setState({selected_cycle: cycle})
            }
        });
        roms.forEach(rom => {
            if (rom.id === this.state.filters.selected_rom){
                this.setState({selected_rom: rom, generating_report:true})
            }
        });

        //Async fetch 360 data...
        Gserv.sendCommand('query_360_for_aggreg',this.props.gwt,{
            filters: this.state.filters
        })
        .then(reports_avail => {
            console.log('query_360_for_aggreg :>> ', reports_avail);
            if (reports_avail.error){
                console.log('error on return from Gserv (query_360_for_aggreg) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reports_avail.Result!=="Success"&&reports_avail.statusCode!==204){
                console.log('error on return from Gserv (query_360_for_aggreg) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                if (reports_avail.Records) {
                    var total = 0;
                    var score = 0;
                    for (var i = 0; i < reports_avail.Records.length; i++){
                        score = Number(reports_avail.Records[i].final_average_score);
                        total += score;
                        reports_avail.Records[i].final_average_score = Math.round(score * 1000) / 1000;        
                    }
                    this.setState({got_360_data:true, three_sixty_array: reports_avail.Records, cycle_ave_360_score: total / i});
                } else {
                    this.setState({got_360_data:true,three_sixty_array:[]});
                }

                if (this.state.got_tm_data){
                    this.setState({report_data_received:true,generating_report:false});
                }

            }
        }); 
 
        //Async fetch tm data...
        Gserv.sendCommand('query_tm_for_aggreg',this.props.gwt,{
            filters: this.state.filters
        })
        .then(reports_avail => {
            console.log('query_tm_for_aggreg :>> ', reports_avail);
            if (reports_avail.error){
                console.log('error on return from Gserv (query_tm_for_aggreg) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reports_avail.Result!=="Success"&&reports_avail.statusCode!==204){
                console.log('error on return from Gserv (query_tm_for_aggreg) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                //Haven't run averages for the moment - may not be that relevant.

                this.setState({got_tm_data:true, tm_array:reports_avail.Records?reports_avail.Records : []});
                if (this.state.got_360_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        }); 


    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            <Grid item>

                {!this.state.generating_report&&!this.state.report_data_received&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >

                    <Typography color='primary' style={{paddingTop:'15px'}}>
                        Aggregate Report for Cycle
                    </Typography>

                    <Card
                        elevation={2}
                        style={{marginTop:'15px'}}
                    >

                        <Grid 
                            container 
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                            style={{padding:'10px', paddingLeft:'50px'}}
                        >

                            {!this.state.got_cycles&&!this.state.error&&
                            <div style={{color:'lightgray'}}>
                                <Settings className='icn-spinner' /> <small><i>loading...</i></small>
                            </div>}

                            {this.state.got_cycles&&
                            <DropDown 
                                fieldMap={{
                                    field: "selected_cycle",
                                    headerName: "Generate Report for Cycle?",f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true
                                }}
                                setField={this.handleFieldUpdate}
                                editRecord={this.state.filters}
                                listArray={this.state.cycles_array}
                                // disabled={this.state.writing}
                            />}

                            {this.state.got_roms&&this.props.admin&&
                            <DropDown 
                                fieldMap={{
                                    field: "selected_rom",
                                    headerName: "Filter by Manager?",f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true
                                }}
                                setField={this.handleFieldUpdate}
                                editRecord={this.state.filters}
                                listArray={this.state.roms_array}
                                // disabled={this.state.writing}
                            />}

                        </Grid>
            
                    </Card>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                        disabled={(!this.state.got_roms&&this.props.admin)||!this.state.got_cycles||!this.state.filters.selected_cycle||!this.state.filters.selected_rom}
                        onClick={this.fetchAggregateData}
                    >
                        Generate Report
                    </Button>

                </Paper>}

                {this.state.generating_report&&!this.state.error&&
                <div>
                    <Settings className='icn-spinner' /> Generating Aggregate Report for Cycle...
                </div>}

                {this.state.report_data_received&&!this.state.error&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            width:'100%',
                            paddingTop: 15,
                            paddingBottom: 15,
                            marginBottom: 2
                        }}
                    >
                        <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.returnToSearch}><UndoTwoTone /></IconButton></Tooltip>

                        <Tooltip title="Print or save as .pdf">
                            <span>
                            <ReactToPrint
                                content={() => this.componentRef}
                                bodyClass={'printSpecs'}
                                trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                            />
                            </span>
                        </Tooltip>

                    </Paper>

                    <div id='Print Delimiter' 
                        ref={(response) => (this.componentRef = response)}
                    >        
                        <style type="text/css" media="print">
                            {"@page { size: landscape; }"}
                        </style>
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >

                            <Typography color='primary' style={{paddingTop:'10px'}}>
                                Aggregate Report for Cycle
                            </Typography>

                            <Typography><b>{this.state.selected_cycle.name}</b></Typography> 
                            
                            {this.state.filters.selected_rom!=="All"&&   
                            <Typography>Filtered for Employees Reporting to : <b>{this.state.selected_rom.name}</b></Typography>}
                        
                        </Card>

                        {this.state.three_sixty_array.length>0&&
                        <div>
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>360 Leadership Assessment Reports on File</Typography>

                            {/* 360 datagrid */}
                            <DatasheetView 
                                dataset={this.state.three_sixty_array}
                                fieldspecs={this.datasheetFieldSpecs_360}
                                delete={false}
                                edit={false}
                                handleDelete={null}
                                handleEdit={null}
                                // loading={this.state.querying}
                                deleteHeaderName={''}
                                // pagesize={10}
                                // height={500}
                            />

                            <Typography
                                style={{padding:'15px'}}
                            >
                                Overall Average Score: <b>{this.state.cycle_ave_360_score}</b>
                            </Typography>

                        </div>}

                        {this.state.tm_array.length>0&&    
                        <div>
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Talent Matrix Reports on File</Typography>

                            {/* 360 datagrid */}
                            <DatasheetView 
                                dataset={this.state.tm_array}
                                fieldspecs={this.datasheetFieldSpecs_tm}
                                delete={false}
                                edit={false}
                                handleDelete={null}
                                handleEdit={null}
                                // loading={this.state.querying}
                                deleteHeaderName={''}
                                // pagesize={10}
                                // height={500}
                            />
                        </div>}

                        {this.state.tm_array.length===0 && this.state.three_sixty_array.length===0 && 
                        <div>
                            <Typography
                                style={{height:'80px', marginTop:'25px'}}
                            >
                                <SearchTwoTone/><br/><i>No reports on file.</i>
                            </Typography>
                        </div>}    
    
                    </div>

                </Paper>}

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center',marginBottom:'15px'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}